import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import { FC } from 'react';
import Button, { ButtonVariant } from './Button';
import { useThemeContext } from 'shared/context/themeContext';
import { dark as darkColors, light as lightColors } from 'shared/theme/colorTokens';

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: ButtonVariant;
}

/**
 * Modal de confirmación genérico con el estilo del nuevo diseño (mismo
 * lenguaje visual que `DeleteModal`, pero neutral y reutilizable para
 * cualquier acción: label y variante del botón de confirmar configurables).
 */
const ConfirmModal: FC<Props> = ({
  open,
  onClose,
  title,
  body,
  onConfirm,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  confirmVariant = 'primary'
}) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: isDark ? darkColors.surface : lightColors.surface
        }
      }}
    >
      <DialogTitle
        className="text-lg font-semibold text-ink dark:text-ink-dark"
        style={{
          background: isDark ? darkColors.pageGradient : lightColors.pageGradient
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <p className="pt-3 text-sm text-ink dark:text-ink-dark">{body}</p>
      </DialogContent>
      <DialogActions>
        <Button variant="secondary" size="sm" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button variant={confirmVariant} size="sm" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
